import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryOverview from './components/CategoryOverview';
import HowToUse from './components/HowToUse';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '禁漫天',
  url: 'https://jinmantian.com/',
  description:
    '禁漫天是广受用户关注的漫画平台，提供官方入口、注册登录方法、内容分类导览及常见问题解答。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://jinmantian.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '禁漫天',
  url: 'https://jinmantian.com/',
  description:
    '禁漫天是国内领先的漫画阅读平台，致力于为漫画爱好者提供海量优质的正版漫画资源和流畅舒适的阅读体验。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'support@jinmantian.com',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
    hoursAvailable: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '09:00',
        closes: '21:00',
      },
    ],
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '禁漫天——官方正版入口与使用指南',
  description:
    '禁漫天是广受用户关注的漫画平台，本页为您提供禁漫天的官方入口、注册登录方法、内容分类导览及常见问题解答，帮助您快速、安全地访问禁漫天，畅享海量漫画资源。',
  url: 'https://jinmantian.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '禁漫天',
    url: 'https://jinmantian.com/',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  useEffect(() => {
    document.title = '禁漫天——官方正版入口与使用指南 | 禁漫天官网';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        '禁漫天是广受用户关注的漫画平台，本页为您提供禁漫天的官方入口、注册登录方法、内容分类导览及常见问题解答，帮助您快速、安全地访问禁漫天，畅享海量漫画资源。'
      );
    }
  }, []);

  return (
    <>
      {/* SEO Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      {/* Hero */}
      <HeroSection />

      {/* Featured Articles */}
      <FeaturedArticles />

      {/* Category Overview */}
      <CategoryOverview />

      {/* How To Use */}
      <HowToUse />

      {/* FAQ */}
      <FAQSection />

      {/* CTA */}
      <CTASection />
    </>
  );
}